
import React from 'react';
import AuthForm from '@/components/AuthForm';

const Index = () => {
  return (
    <div className="min-h-screen bg-white flex items-center justify-center px-4 py-8 relative">
      <div className="w-full max-w-xs relative">
        <AuthForm />
      </div>
    </div>
  );
};

export default Index;
